import * as React from 'react';
import { connect } from 'react-redux';
import { ISeat } from '../../classes/package-listing';
import { IPackageListingAppState } from '../../redux-state';
import { updateSeatingChoice } from '../../redux-state/actions/package-listing.actions';
import SeatingChoiceView from '../../views/library/package-cart-seating-choice.view';

interface StateToProps {
    originalSeats: Array<ISeat>;
    seatingChoice: Array<number>;
    currentNumberOfSeats: number;
    seatSelectionDescription: string;
}

interface DispatchToProps {
    updateSeatingChoice: (seatChoice: number) => void;
}

export type SeatingChoiceProps = StateToProps & DispatchToProps;

export class SeatingChoiceBase extends React.Component<SeatingChoiceProps, any> {
    constructor(props: SeatingChoiceProps) {
        super(props);
    }

    render() {
        return <SeatingChoiceView {...this.props} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: SeatingChoiceProps): StateToProps {
    return {
        originalSeats: state.packageListing.originalSeats,
        seatingChoice: state.packageListing.seatingChoice,
        currentNumberOfSeats: state.packageListing.totalNumberOfTicket,
        seatSelectionDescription: state.packageListingText.seatSelectionDescription
    }
}

function mapDispatchToProps(dispatch, ownProps: SeatingChoiceProps): DispatchToProps {
    return {
        updateSeatingChoice: (seatingChoice) => {
            dispatch(updateSeatingChoice(seatingChoice));
        }

    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(SeatingChoiceBase)